import React from "react";
import { Route, Switch } from "react-router-dom";
import SidebarForTeacher from "../teacherComponents/SidebarForTeacher";
// import NewsfeedSection from "../teacherComponents/Newsfeed/NewsfeedSection";
import Tabs from "../teacherComponents/TeacherTabs/Tabs";
import Evaluation from "../teacherComponents/ClassEvaluation/Evaluation";
import Planner from "../teacherComponents/Planner/Planner";
import TabsForRouting from "../teacherComponents/TabsForRouting/TabsForRouting";
import ClassStart from "../teacherComponents/ClassStart/ClassStart";
import ClassStart2 from "../teacherComponents/ClassStart/ClassStart2";
import VideoFeedback from "../teacherComponents/VideoFeedback/VideoFeedback";
import MyAvailability from "../teacherComponents/MyAvailability/MyAvailability";
import ClassStart3 from "../teacherComponents/ClassStart/ClassStart3";
import UploadHomework from "./tutorViews/uploadHomework/UploadHomework";
import UploadHomeworkMultiple from "./tutorViews/uploadHomework/UploadHomeworkMultiple";
import RecruitmentTab from "../teacherComponents/RecruitmentProcess/RecruitmentTab";
import TutorFeeds from "../teacherComponents/TutorFeeds/tutorFeeds";

const FeedComponentForTeacher = () => {
  return (
    <SidebarForTeacher>
      <Switch>
        {/* <Route exact component={NewsfeedSection} path="/Teacherdashboard" /> */}
        <Route component={Evaluation} path="/Teacherdashboard/Evaluation" />
        <Route component={Tabs} path="/Teacherdashboard/OngoingClasses" />
        <Route component={Planner} path="/Teacherdashboard/Planner" />
        <Route component={ClassStart} path="/Teacherdashboard/ClassStart2" />
        <Route component={ClassStart2} path="/Teacherdashboard/ClassStart" />
        <Route component={ClassStart3} path="/Teacherdashboard/ClassStart3" />
        <Route component={VideoFeedback} path="/Teacherdashboard/VideoFeedback" />
        <Route component={UploadHomeworkMultiple} path="/Teacherdashboard/UploadHomework" />
        <Route component={MyAvailability} path="/Teacherdashboard/MyAvailability" />
        <Route component={TutorFeeds} path="/Teacherdashboard/home" />
        <Route component={RecruitmentTab} path="/Teacherdashboard/RecruitmentTab/:username?/:password?" />
      </Switch>
    </SidebarForTeacher>
  );
};

export default FeedComponentForTeacher;
